// extracted by mini-css-extract-plugin
export default {"profilePageContainer":"ProfilePageContainer_profilePageContainer__Ek-I8"};